
import PageInfo from './pageInfo'
import Center from './center'
import PromoInfo from './promo'
import mmpAuth from './mmpAuth'
import cartInfo from './cartInfo'
import mmpRoute from './mmpRoute'
import loading from './loading'

import homeInfo from './nrw/homeInfo' // 모바일웹 Home (Home 정보 및 프로모션 카테고리 포틀릿 처리)
import courseList from './nrw/courseList' // 과정목록 공통
// lee.chang
import mySpaceLrn from './nrw/mySpaceLrn' // 나의공간 - 학습목록

import custCntr from './nrw/custCntr' // 고객센터

import eduCal from './nrw/eduCal' // 교육캘린더

// 사용자 커스터 마이징
const register = () => {
  return [PageInfo, Center, PromoInfo, mmpAuth, cartInfo, mmpRoute, loading, homeInfo, courseList, mySpaceLrn, custCntr, eduCal]
}

let registerLocalStore = {}
registerLocalStore.register = register

export default registerLocalStore



// WEBPACK FOOTER //
// ./src/config/vuex/register.js